export function defaultIfUndefined<T>(value: T | undefined, fallback: T): T {
  if (value === undefined) return fallback;

  return value;
}
